module.exports = __webpack_public_path__ + "img/039-error-404-colour.803c3242.svg";